module.exports = __webpack_public_path__ + "img/tdk__logo.2e7aa66f.svg";